import * as React from "react";
import {observer} from "mobx-react";
import {RouteComponentProps} from "react-router";
import FormStepper, {IStep} from "../../components/FormStepper/FormStepper";
import {SBAPages} from "./FormSBASteps/SBATypes";
import {InputTypes} from "../../components/FormStepper/InputTypes";
import FormButton from "../../../../components/FormButton/FormButton";
import {WithStyles, withStyles} from "@material-ui/core/styles";
import {toJS} from "mobx";
import {ESBABusinessType, ESBALoanPurpose} from "shared/model/IApplication";
import Loader from "src/components/Loader/Loader";
import {
    BUSINESS_TEXTS,
    CALCULATOR_TEXTS,
    DOCUMENTATION_TEXT,
    FINAL_FINISH_TEXTS,
    FINANCE_TEXTS,
    FIRST_FINISH_TEXTS,
    GENERAL_QUESTIONS_TEXT,
    OWNERSHIP_TEXT
} from "./SBAFormTexts"

const INITIAL_SCREEN = SBAPages.business;
const backAllowedPages = [SBAPages.loanCalculator, SBAPages.ownership, SBAPages.general, SBAPages.documentation, SBAPages.finance];

interface IProps extends RouteComponentProps<any> {
    store: any;
}

interface ILocalState {
    currentPage: SBAPages;
    additionalOwnership: boolean | undefined;
    isFormFinished: boolean;
    isFirstThankYouPageLoading: boolean;
}

const styles: ({palette, breakpoints}: { palette: any; breakpoints: any }) => {} = ({ palette, breakpoints }) => ({
    nextContainer: {
        width: "35%",
        marginLeft: "auto",
        [breakpoints.down("sm")]: {
            marginBottom: "1em"
        }
    },
    finishTextContainer: {
        marginTop: "40%"
    },
    finishText: {
        fontSize: 20,
        fontWeight: "bold",
        textAlign: "center",
        color: "#2f3033",
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        marginBottom: "1em"
    },
    finishTextSubHeader: {
        fontSize: 15,
        marginBottom: "1em",
        fontWeight: 500,
        color: "#2f3033",
        textAlign: "center"
    },
    skip: {
        fontSize: 13,
        fontWeight: 600,
        color: "#9ca6ad",
        textDecoration: "underline",
        marginLeft: "auto",
        cursor: "pointer",
        position: "absolute",
        left: "85%",
        top: ".5em",
        width: "fit-content",
        [breakpoints.down("sm")]: {
            top: "-.5em",
        }
    },
    expParagraph: {
        fontSize: 12,
        fontWeight: 500,
        color:"#9ca6ad",
        marginBottom: "1em"
    },
    navigationContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "90%",
        margin: "1em auto",
        // [breakpoints.down("sm")]: {
        //     margin: "auto",
        //     display: "block"
        // }
    },
    backButton: {
        fontSize: 14,
        fontWeight: 500,
        color: "#9ca6ad",
        display: "flex",
        flexDirection: "column",
        margin: "auto 0",
        cursor: "pointer"
    }
});

@observer
@(withStyles(styles) as any)
export default class FormSBA  extends React.Component<
    IProps & Partial<WithStyles<any>>,
    ILocalState
    > {
    public state: ILocalState = {
        currentPage: INITIAL_SCREEN,
        additionalOwnership: undefined,
        isFormFinished: false,
        isFirstThankYouPageLoading : true

    };

    constructor(props: IProps) {
        super(props);
        props.store.formInput[this.state.currentPage] = {};
    }

    public renderNextButton = () => {
        const {classes} = this.props;
        const isFormFinished = this.state.isFormFinished;
        const className = isFormFinished ? "blue" : "disabled" ;
        const btnText = this.state.currentPage === SBAPages.documentation ? "Done" : "Next";
        return <div className={classes!.nextContainer}> <FormButton btnText={btnText} classes={className} click={this.navigateNext}/> </div>
    };

    public renderBackButton = () => {
        const {classes} = this.props;
        if(backAllowedPages.includes(this.state.currentPage)) {
            return <div className={classes!.backButton} onClick={this.navigateBack}>Back</div>
        }
        return null;
    }

    public renderFormNavigation = () => {
        const {classes, store} = this.props;
        return (
            <div className={classes!.navigationContainer}>
                {!store.isAfterFollowUpLink && this.renderBackButton()}
                {this.renderNextButton()}
            </div>
        )
    };

    public renderCalculatorExplanationsIfNeeded = () => {
        const {classes} = this.props;
        if(this.state.currentPage === SBAPages.loanCalculator) {
            return (
                <>
                    <div className={classes!.expParagraph}>{CALCULATOR_TEXTS.EXPLANATION_TEXTS.PARAGRAPH_A}</div>
                    <div className={classes!.expParagraph}>{CALCULATOR_TEXTS.EXPLANATION_TEXTS.PARAGRAPH_B}</div>
                </>
            )
        }
        return null
    };

    public renderForm = () => {
        this.changeToUploadFilesScreenIfNeeded()
        return (<>
                {/*{this.renderSkipOptionIfNeeded()}*/}
                <FormStepper steps={this.getFormStepsFiltered()} store={this.props.store} navigationProperty={this.state.currentPage} updateParentFormStatus={this.getFormStatus}/>
                {this.renderCalculatorExplanationsIfNeeded()}
                {this.renderFormNavigation()}
            </>
        )
    };

    public changeToUploadFilesScreenIfNeeded() {
        const {store} = this.props
        if (store.needToInitUIPage) {
            store.needToInitUIPage = false;
            const newState = this.state
            newState.currentPage = SBAPages.documentation
            this.setState(newState)
        }
    }

    public renderFirstThankYouPage = () => {
        const {classes, store} = this.props;
        const {isFirstThankYouPageLoading} = this.state;
        if (isFirstThankYouPageLoading) {
            setTimeout(() => {
                const newState = this.state;
                newState.isFirstThankYouPageLoading = store.isSending || false;
                this.setState(newState);
            }, 500);
            return  (<>
                <Loader/>
            </>)
        } else {
            return (
                <div className={classes!.finishTextContainer}>
                    <div className={classes!.finishText}>{FIRST_FINISH_TEXTS.HEADER}</div>
                    <div className={classes!.finishTextSubHeader}>{FIRST_FINISH_TEXTS.SUB_HEADER}</div>
                    <FormButton btnText={"Upload Docs"} classes={"blue"} click={this.navigateNext}/>
                </div>
            )
        }
    };

    public renderFinalThankYouPage = () => {
        const {classes} = this.props;
        return (
            <div className={classes!.finishTextContainer}>
                <div className={classes!.finishText}>{FINAL_FINISH_TEXTS.HEADER}</div>
                <div className={classes!.finishTextSubHeader}>{FINAL_FINISH_TEXTS.SUB_HEADER}</div>
            </div>
        )
    };

    public render() {
        switch (this.state.currentPage) {
            case SBAPages.firstThankYou: return this.renderFirstThankYouPage(); break;
            case SBAPages.finalThankYou: return this.renderFinalThankYouPage(); break;
            default: return this.renderForm()
        }
    }

    private generateCompanyTypes = () => {
        return Object.keys(ESBABusinessType).map((key) => ({value: ESBABusinessType[key], label: ESBABusinessType[key]}));
    };

    private updateSelectedBusinessType = (value: string) => {
        const {store} = this.props;
        store.formInput.business.businessType = value;
    };

    private generateLoanPurposes = () => {
        return Object.keys(ESBALoanPurpose).map((key) => ({value: ESBALoanPurpose[key], label: ESBALoanPurpose[key]}));
    };

    private getLoanPurposes = (selectedReasons: string[]) => {
        this.props.store.formInput[this.state.currentPage][FINANCE_TEXTS.PROP_NAMES.LOAN_PURPOSE] = selectedReasons;
    }

    private navigateNext = async () => {
        const {store} = this.props;
        const {additionalOwnership, isFormFinished, currentPage} = this.state;
        if (this.state.currentPage === SBAPages.ownership && isFormFinished && additionalOwnership) {
            this.props.store.formInput[this.state.currentPage] = {};
            document.getElementsByClassName("form-container")[0].scrollTo(0,0);
        }
        if(this.state.isFormFinished || currentPage === SBAPages.firstThankYou) {
            if(currentPage === SBAPages.ownership) {
                store.saveOwnership();
            }
            const newState = this.state;
            newState.currentPage = this.getNextPage();
            newState.isFormFinished = false;
            this.props.store.formInput[newState.currentPage] = {};
            store.updateCurrentScreen(newState.currentPage);
            if (newState.currentPage === SBAPages.firstThankYou) {
                this.props.store.submit();
                newState.isFirstThankYouPageLoading = true;
            }
            if (newState.currentPage === SBAPages.finance) {
                this.props.store.formInput.finance.loanAmount = Math.round(this.props.store.formInput.loanCalculator.maximumLoan).toString() 
            }
            this.setState(newState);
            document.getElementsByClassName("form-container")[0].scrollTo(0,0);
        }
    };

    private navigateBack = async () => {
        const {store} = this.props;
        console.log(toJS(this.props.store.formInput));
        if(this.state.currentPage === SBAPages.ownership && store.getOwnershipArray().length > 0) {
            store.restoreLastUser();
            this.setState(this.state);
        }else {
            const newState = this.state;
            newState.currentPage = this.getPrevPage();
            newState.isFormFinished = false;
            this.props.store.formInput[newState.currentPage] = {};
            this.setState(newState);
        }
    };

    private getNextPage = () => {
        switch (this.state.currentPage) {
            case SBAPages.business: return SBAPages.loanCalculator;
            case SBAPages.loanCalculator: return SBAPages.finance;
            case SBAPages.finance: return SBAPages.ownership;
            case SBAPages.ownership: return SBAPages.general;
            case SBAPages.general: return SBAPages.firstThankYou;
            case SBAPages.firstThankYou: return SBAPages.documentation;
            case SBAPages.documentation: return SBAPages.finalThankYou;
            default: return SBAPages.business;
        }
    }

    private getPrevPage = () => {
        switch (this.state.currentPage) {
            case SBAPages.documentation: return SBAPages.general;
            case SBAPages.general: return SBAPages.ownership;
            case SBAPages.ownership: return SBAPages.finance;
            case SBAPages.finance: return SBAPages.loanCalculator;
            case SBAPages.loanCalculator: return SBAPages.business;
            default: return SBAPages.business;
        }
    }

    private getFormStepsFiltered = () => {
        const steps = this.getFormSteps() as IStep[]
        const filteredSteps = steps.filter(item => item !== undefined)
        // filteredSteps.map((step, index) => console.log(index, step.propName))
        return filteredSteps
    }
    private getFormSteps = () => {
        const {store} = this.props;
        switch (this.state.currentPage) {
            case SBAPages.business: return [
                {
                    isHeader: true,
                    title: BUSINESS_TEXTS.HEADERS.MAIN_HEADER,
                    inputType: InputTypes.none
                },
                {
                    title: BUSINESS_TEXTS.HEADERS.FULL_NAME,
                    propName: BUSINESS_TEXTS.PROP_NAMES.FULL_NAME,
                    inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.GENERAL,
                    inputType: InputTypes.text
                },
                {
                    title: BUSINESS_TEXTS.HEADERS.EMAIL_ADDRESS,
                    propName: BUSINESS_TEXTS.PROP_NAMES.EMAIL_ADDRESS,
                    inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.GENERAL,
                    inputType: InputTypes.email
                },
                {
                    title: BUSINESS_TEXTS.HEADERS.BUSINESS_TYPE,
                    propName: BUSINESS_TEXTS.PROP_NAMES.BUSINESS_TYPE,
                    inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.BUSINESS_TYPE,
                    options: this.generateCompanyTypes(),
                    cb: this.updateSelectedBusinessType,
                    inputType: InputTypes.dropdown
                },
                {
                    title: BUSINESS_TEXTS.HEADERS.EMPLOYEES,
                    propName: BUSINESS_TEXTS.PROP_NAMES.EMPLOYEES,
                    inputType: InputTypes.number,
                    inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.GENERAL,
                    errorController: store.employeeLimitFlag,
                    errorLabel: BUSINESS_TEXTS.HEADERS.EMPLOYEES_ERROR,
                },
                {
                    title: BUSINESS_TEXTS.HEADERS.BUSINESS_NAME,
                    propName: BUSINESS_TEXTS.PROP_NAMES.BUSINESS_NAME,
                    inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.GENERAL,
                    inputType: InputTypes.text
                },
                {
                    title: BUSINESS_TEXTS.HEADERS.DBA,
                    propName: BUSINESS_TEXTS.PROP_NAMES.DBA,
                    inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.GENERAL,
                    inputType: InputTypes.text
                },
                {
                    title: BUSINESS_TEXTS.HEADERS.BUSINESS_TIN,
                    propName: BUSINESS_TEXTS.PROP_NAMES.BUSINESS_TIN,
                    inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.GENERAL,
                    inputType: InputTypes.number,
                    customValidationCheck: this.validate9CharactersLength,
                    errorLabel: OWNERSHIP_TEXT.HEADERS.TIN_ERROR,
                },
                {
                    title: BUSINESS_TEXTS.HEADERS.BUSINESS_PHONE,
                    subTitle: BUSINESS_TEXTS.HEADERS.BUSINESS_PHONE_SUB_HEADER,
                    propName: BUSINESS_TEXTS.PROP_NAMES.BUSINESS_PHONE,
                    inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.CELL_PHONE_NUMBER,
                    inputType: InputTypes.phoneNumber
                },
                {
                    title: BUSINESS_TEXTS.HEADERS.BUSINESS_ADDRESS,
                    propName: BUSINESS_TEXTS.PROP_NAMES.BUSINESS_ADDRESS,
                    inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.BUSINESS_ADDRESS,
                    inputType: InputTypes.locationSearch
                },
            ] ;
            case SBAPages.finance: return [
                {
                    isHeader: true,
                    title: FINANCE_TEXTS.HEADERS.MAIN_HEADER,
                    inputType: InputTypes.none
                },
                {
                    title: FINANCE_TEXTS.HEADERS.LOAN_REQUEST,
                    propName: FINANCE_TEXTS.PROP_NAMES.LOAN_REQUEST,
                    inputType: InputTypes.amount,
                    shortInput: true,
                    customValidationCheck: this.customAmountValidtion
                },
                {
                    title: FINANCE_TEXTS.HEADERS.LOAN_PURPOSE,
                    propName: FINANCE_TEXTS.PROP_NAMES.LOAN_PURPOSE,
                    inputType: InputTypes.multipleCheckSelect,
                    options: this.generateLoanPurposes(),
                    selectedOption: this.getLoanPurposes
                },
                {
                    title: FINANCE_TEXTS.HEADERS.ACCOUNT_ROUTING,
                    subTitle: FINANCE_TEXTS.HEADERS.BANK_NAME_SUB_HEADER,
                    propName: FINANCE_TEXTS.PROP_NAMES.ACCOUNT_ROUTING,
                    customValidationCheck: this.validate9CharactersLength,
                    errorLabel: FINANCE_TEXTS.HEADERS.ROUTING_ERROR,
                    inputType: InputTypes.text,
                    inputPlaceHolder: FINANCE_TEXTS.PLACE_HOLDERS.GENERAL,
                    postFinishCB: this.fetchBankName
                },
                {
                    title: FINANCE_TEXTS.HEADERS.ACCOUNT_NUMBER,
                    propName: FINANCE_TEXTS.PROP_NAMES.ACCOUNT_NUMBER,
                    inputType: InputTypes.number,
                    inputPlaceHolder: FINANCE_TEXTS.PLACE_HOLDERS.GENERAL
                },
                {
                    title: FINANCE_TEXTS.HEADERS.ACCOUNT_OWNER,
                    propName: FINANCE_TEXTS.PROP_NAMES.ACCOUNT_OWNER,
                    inputType: InputTypes.text,
                    inputPlaceHolder: FINANCE_TEXTS.PLACE_HOLDERS.GENERAL,


                },
                {
                    title: FINANCE_TEXTS.HEADERS.BANK_NAME,
                    propName: FINANCE_TEXTS.PROP_NAMES.BANK_NAME,
                    inputType: InputTypes.text,
                    inputPlaceHolder: FINANCE_TEXTS.PLACE_HOLDERS.GENERAL
                }
            ];
            case SBAPages.general: return [
                {
                    isHeader: true,
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.MAIN_HEADER,
                    subTitle: GENERAL_QUESTIONS_TEXT.HEADERS.SUB_HEADER,
                    inputType: InputTypes.none
                },
                {
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.Q1,
                    propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q1,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.updateAnswer
                        } ,
                        {
                            text: "No",
                            cta: this.updateAnswer
                        }
                    ],
                    selectedOption: this.getValuePerQuestion(GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q1)
                },
                {
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.Q2,
                    propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q2,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.updateAnswer
                        } ,
                        {
                            text: "No",
                            cta: this.updateAnswer
                        }
                    ],
                    selectedOption: this.getValuePerQuestion(GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q2)
                },
                {
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.Q3,
                    propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q3,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.updateAnswer
                        } ,
                        {
                            text: "No",
                            cta: this.updateAnswer
                        }
                    ],
                    selectedOption: this.getValuePerQuestion(GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q3)
                },
                {
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.Q4,
                    propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q4,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.updateAnswer
                        } ,
                        {
                            text: "No",
                            cta: this.updateAnswer
                        }
                    ],
                    selectedOption: this.getValuePerQuestion(GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q4)
                },
                {
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.Q5,
                    propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q5,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.updateAnswer
                        } ,
                        {
                            text: "No",
                            cta: this.updateAnswer
                        }
                    ],
                    selectedOption: this.getValuePerQuestion(GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q5)
                },
                {
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.Q6,
                    propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q6,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.updateAnswer
                        } ,
                        {
                            text: "No",
                            cta: this.updateAnswer
                        }
                    ],
                    selectedOption: this.getValuePerQuestion(GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q6)
                },
                {
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.Q7,
                    propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q7,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.updateAnswer
                        } ,
                        {
                            text: "No",
                            cta: this.updateAnswer
                        }
                    ],
                    selectedOption: this.getValuePerQuestion(GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q7)
                },
                {
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.Q8,
                    propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q8,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.updateAnswer
                        } ,
                        {
                            text: "No",
                            cta: this.updateAnswer
                        }
                    ],
                    selectedOption: this.getValuePerQuestion(GENERAL_QUESTIONS_TEXT.PROP_NAMES.Q8)
                },
                {
                    title: GENERAL_QUESTIONS_TEXT.HEADERS.BANK_QUESTION,
                    propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.BANK_QUESTION,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.updateAnswer
                        } ,
                        {
                            text: "No",
                            cta: this.updateAnswer
                        }
                    ],
                    selectedOption: this.getValuePerQuestion(GENERAL_QUESTIONS_TEXT.PROP_NAMES.BANK_QUESTION)
                },
                this.renderBankEmailAddressIfNeeded()
            ];
            case SBAPages.ownership: return [
                {
                    isHeader: true,
                    title: OWNERSHIP_TEXT.HEADERS.MAIN_HEADER,
                    subTitle: OWNERSHIP_TEXT.HEADERS.MAIN_SUB_HEADER,
                    secondSubTitle: this.generateOwnersSubTitle(),
                    inputType: InputTypes.none
                },
                    {
                        title: OWNERSHIP_TEXT.HEADERS.OWNER_NAME,
                        propName: OWNERSHIP_TEXT.PROP_NAMES.OWNER_NAME,
                        inputType: InputTypes.text,
                        inputPlaceHolder: OWNERSHIP_TEXT.PLACE_HOLDERS.GENERAL
                    },
                    {
                        title: OWNERSHIP_TEXT.HEADERS.TITLE,
                        propName: OWNERSHIP_TEXT.PROP_NAMES.TITLE,
                        inputType: InputTypes.text,
                        inputPlaceHolder: OWNERSHIP_TEXT.PLACE_HOLDERS.GENERAL
                    },
                    {
                        title: OWNERSHIP_TEXT.HEADERS.OWNERSHIP,
                        propName: OWNERSHIP_TEXT.PROP_NAMES.OWNERSHIP,
                        inputType: InputTypes.number,
                        inputPlaceHolder: OWNERSHIP_TEXT.PLACE_HOLDERS.GENERAL,
                        customValidationCheck : this.customPercentageValidation,
                        errorLabel: OWNERSHIP_TEXT.HEADERS.OWNERSHIP_ERROR,
                    },
                    {
                        title: OWNERSHIP_TEXT.HEADERS.TIN,
                        propName: OWNERSHIP_TEXT.PROP_NAMES.TIN,
                        inputType: InputTypes.number,
                        inputPlaceHolder: OWNERSHIP_TEXT.PLACE_HOLDERS.GENERAL,
                        customValidationCheck: this.validate9CharactersLength,
                        errorLabel: OWNERSHIP_TEXT.HEADERS.TIN_ERROR,
                    },
                    {
                        title: OWNERSHIP_TEXT.HEADERS.ADDRESS,
                        propName: OWNERSHIP_TEXT.PROP_NAMES.ADDRESS,
                        inputType: InputTypes.locationSearch,
                        inputPlaceHolder: OWNERSHIP_TEXT.PLACE_HOLDERS.ADDRESS,
                        selectedOption: store.formInput.ownership[OWNERSHIP_TEXT.PROP_NAMES.ADDRESS]
                    },
                this.getAnotherOwnershipStep()
            ];
            case SBAPages.documentation: return [
                {
                    isHeader: true,
                    title: DOCUMENTATION_TEXT.HEADERS.MAIN_HEADER,
                    subTitle: DOCUMENTATION_TEXT.HEADERS.MAIN_SUB_HEADER,
                    inputType: InputTypes.none
                },
                {
                    title: DOCUMENTATION_TEXT.HEADERS.FIRST_PDF,
                    subTitle: DOCUMENTATION_TEXT.HEADERS.FIRST_PDF_SUB_HEADER,
                    inputType: InputTypes.file,
                    propName:  DOCUMENTATION_TEXT.PROP_NAMES.FIRST_PDF,
                },
                {
                    title: DOCUMENTATION_TEXT.HEADERS.SECOND_PDF,
                    inputType: InputTypes.file,
                    propName:  DOCUMENTATION_TEXT.PROP_NAMES.SECOND_PDF,
                },
                {
                    title: DOCUMENTATION_TEXT.HEADERS.THIRD_PDF,
                    inputType: InputTypes.file,
                    propName:  DOCUMENTATION_TEXT.PROP_NAMES.THIRD_PDF,
                    isOptional: true
                },

            ];
            case SBAPages.loanCalculator: return [
                {
                    isHeader: true,
                    title: CALCULATOR_TEXTS.HEADERS.MAIN_HEADER,
                    subTitle: CALCULATOR_TEXTS.HEADERS.MAIN_SUB_HEADER,
                    inputType: InputTypes.none,
                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.AGGREGATE_PAYROLL_COSTS,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.AGGREGATE_PAYROLL_COSTS,
                    inputType: InputTypes.nested,
                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.WAGES,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.WAGES,
                    inputType: InputTypes.amount
                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.TIPS,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.TIPS,
                    inputType: InputTypes.amount
                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.VACATION,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.VACATION,
                    inputType: InputTypes.amount
                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.ALLOWANCE,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.ALLOWANCE,
                    inputType: InputTypes.amount
                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.EMPLOYEE_BENEFITS,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.EMPLOYEE_BENEFITS,
                    inputType: InputTypes.amount
                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.TAXES,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.TAXES,
                    inputType: InputTypes.amount
                },
                {
                    title: CALCULATOR_TEXTS.RESULT_HEADERS.ANNUAL_PAYROLL,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.ANNUAL_PAYROLL,
                    isLocked: true,
                    shortInput: true,
                    inputType: InputTypes.amount,
                    specialTitleStyle: {
                        fontWeight: 600
                    },
                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.INDIVIDUAL,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.INDIVIDUAL,
                    inputType: InputTypes.amount
                },
                {
                    title: CALCULATOR_TEXTS.RESULT_HEADERS.ADJUSTED_PAYROLL,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.ADJUSTED_PAYROLL,
                    inputType: InputTypes.amount,
                    isLocked: true,
                    shortInput: true,
                    specialTitleStyle: {
                        fontWeight: 600
                    },
                },
                {
                    title: CALCULATOR_TEXTS.RESULT_HEADERS.MONTHLY_PAYROLL,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.MONTHLY_PAYROLL,
                    inputType: InputTypes.amount,
                    isLocked: true,
                    shortInput: true,
                    specialTitleStyle: {
                        fontWeight: 600
                    },
                },
                {
                    title: CALCULATOR_TEXTS.RESULT_HEADERS.MULTIPLE,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.MULTIPLE,
                    inputType: InputTypes.amount,
                    isLocked: true,
                    shortInput: true,
                    specialTitleStyle: {
                        fontWeight: 600
                    },
                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.OUTSTANDING_BALANCE,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.OUTSTANDING_BALANCE,
                    inputType: InputTypes.amount,

                },
                {
                    title: CALCULATOR_TEXTS.HEADERS.ADVANCE,
                    propName: CALCULATOR_TEXTS.PROP_NAMES.ADVANCE,
                    inputType: InputTypes.amount,
                },
                {
                    title: CALCULATOR_TEXTS.RESULT_HEADERS.MAXIMUM,
                    specialTitleStyle: {
                        fontWeight: 600
                    },
                    propName: CALCULATOR_TEXTS.PROP_NAMES.MAXIMUM_LOAN,
                    inputType: InputTypes.amount,
                    isLocked: true,
                },
            ];
            default: return []
        }
    };

    private renderBankEmailAddressIfNeeded = () => {
        const {store} = this.props;
        const isRenderNeeded = store.formInput.general[GENERAL_QUESTIONS_TEXT.PROP_NAMES.BANK_QUESTION]
        if (isRenderNeeded) {
            return {
                title: GENERAL_QUESTIONS_TEXT.HEADERS.BANK_EMAIL_ADDRESS,
                propName: GENERAL_QUESTIONS_TEXT.PROP_NAMES.BANK_EMAIL_ADDRESS,
                inputPlaceHolder: BUSINESS_TEXTS.PLACE_HOLDERS.GENERAL,
                inputType: InputTypes.email
            }
        }
        return undefined

    }
    private getValuePerQuestion = (propName: string) => {
        const {store} = this.props;
        return store.formInput.general[propName] === ""? undefined: store.formInput.general[propName];
    };

    private updateAnswer = (inputAnswer: any) => {
        const {store} = this.props;
        store.formInput.general[inputAnswer.propName] = inputAnswer.answer;
        // console.log(inputAnswer.propName, inputAnswer.answer)
        if (inputAnswer.propName === GENERAL_QUESTIONS_TEXT.PROP_NAMES.BANK_QUESTION && !inputAnswer.answer) {
            delete store.formInput.general.bankEmailAddress
            // console.log(JSON.stringify(store.formInput.general))
        }
        this.setState(this.state);
    }

    private updateAnotherOwnership = (inputAnswer: any) => {
        const {store} = this.props;
        const newAnswer = inputAnswer.answer;
        store.formInput.ownership[inputAnswer.propName] = newAnswer;
        if(newAnswer) {
            store.saveOwnership();
            const newState = this.state;
            newState.additionalOwnership = true;
            this.setState(newState);
            store.formInput.ownership = {}
        }else {
            const newState = this.state;
            newState.additionalOwnership = false;
            this.setState(this.state);
        }
    }

    private getFormStatus = (formStatus: boolean) => {
        const newState = this.state;
        if(formStatus && !this.state.isFormFinished) {
            newState.isFormFinished = true;
            this.setState(newState);
        }
        if(!formStatus && this.state.isFormFinished) {
            newState.isFormFinished = false;
            this.setState(newState);
        }
    };

    private customAmountValidtion = (inputValue:string) => {
        const newVal = inputValue.split(",").join()
        const val = parseInt(newVal, 10)
        if (val > 0) {
            return true;
        }
        return false
    }

    private customPercentageValidation = (inputValue:string) => {
        const val = parseInt(inputValue, 10);
        if (val >= 20 && val <= 100 && inputValue.length > 0 ) {
            return true;
        }
        return false;
    }

    private generateOwnersSubTitle = () => {
        const {store} = this.props;
        const ownerNum = store.ownershipsArr.length + 1;
        return "Owner " + ownerNum;
    };

    private validate9CharactersLength = (val: string) => {
        return val.length === 0? false : val.length === 9;
    };

    private fetchBankName = (routingNumber: string) => {
        this.props.store.bankRoutingNumber = routingNumber;
        this.props.store.fetchBankName();
    }

    private getAnotherOwnershipStep = () => {
        const {store} = this.props;
            // If the array has 4 owners already, the next one will be the last
            if(store.ownershipsArr.length === 4) {
                if(this.state.additionalOwnership) {
                    const newState = this.state;
                    newState.additionalOwnership = false;
                    this.setState(newState);
                }
                return {
                    title: "",
                    subTitle: "Maximum of 5 ownerships allowed",
                    propName: OWNERSHIP_TEXT.PROP_NAMES.ANOTHER_OWNERSHIP,
                    inputType: InputTypes.none
                }

            }
        return {
            title: OWNERSHIP_TEXT.HEADERS.ANOTHER_OWNERSHIP,
            inputType: InputTypes.boolean,
            propName: OWNERSHIP_TEXT.PROP_NAMES.ANOTHER_OWNERSHIP,
            options: [
                {
                    text: "Yes",
                    cta: this.updateAnotherOwnership
                },
                {
                    text: "No",
                    cta: this.updateAnotherOwnership
                }
            ],
            selectedOption: store.formInput.ownership[OWNERSHIP_TEXT.PROP_NAMES.ANOTHER_OWNERSHIP]
            //     }
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormSBA/FormSBA.tsx